import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    headerContainer: {
      backgroundColor: '#F0F0F0',
      color: '#001D29',
      padding: '16px',
      borderRadius: '5px',
    },
    titleText: {
      fontSize: '18px',
      marginBottom: '12px',
    },
    descriptionText: {
      fontSize: '11px',
      lineHeight: '16px',
      fontWeight: 600,
    },
  }),
)
